export * as City from './city';
export * as Competence from './competence';
export * as Country from './country';
export * as CustomField from './custom-field';
export * as Department from './department';
export * as Generic from './generic';
export * as MailAttachment from './mail-attachment';
export * as MailTemplate from './mail-template';
export * as Region from './region';
export * as RejectReason from './reject-reason';
export * as Sets from './sets';
export * as ShortlistStatus from './shortlist-status';
export * as Skill from './skill';
export * as Speciality from './speciality';
export * as Tag from './tag';

export enum CommonDictionaryName {
  city = 'city',
  competence = 'competence',
  country = 'country',
  currency = 'currency',
  duration = 'duration',
  employment = 'employment',
  'english-level' = 'english-level',
  experience = 'experience',
  mainSkill = 'mainSkill',
  'profile-source' = 'profile-source',
  region = 'region',
  'shortlist-source' = 'shortlist-source',
  skill = 'skill',
  'soft-skill' = 'soft-skill',
  speciality = 'speciality',
  'vacancy-status' = 'vacancy-status',
}
export enum PortalSpecificDictionaryName {
  address = 'address',
  department = 'department',
  'mail-attachment' = 'mail-attachment',
  'mail-template' = 'mail-template',
  'reject-reason' = 'reject-reason',
  'shortlist-status' = 'shortlist-status',
  tag = 'tag',
}

export type DictionaryName =
  | CommonDictionaryName
  | PortalSpecificDictionaryName;
